export default {
     liStyle:{
        
        display: "table-cell",
        height: "38px",	
        width: "38px",
        color:"#888",
        border: "2px solid #B4CF47",
        float:"left",
        position:"relative",
        marginRight:"5px",
        marginBottom:"5px",
        textAlign:"center",
    },
    
     inputStyle:{
        height: "38px",
        maxWidth: "442px",
        width:"100%",
        border: "2px solid #B4CF47",
        fontSize:"16px",
        backgroundColor:"transparent"
    },
     aStyle:{
        color:"#000",
        textDecoration:"none",
        //position:"absolute",
        //top:"10%",
        //left:"8%",
        fontFamily:"Roboto", 
        border:"none", 
        backgroundColor:"transparent",
        fontSize:"24px",
        padding:"4px 8px",
    },
     buttonStyle:{
        height: "38px",
        border: "none",
        marginTop: "-35px",
        float: "right",
        marginRight: "10px",
        zInex:"99",
        backgroundColor:" transparent",
        
    },
     formStyle:{
        position:"relative",
        maxWidth: "442px",
        width:"100%",
    },
  


}